import { SELECT_ALL_VALUE } from "@/core/components/shared/data-table";
import { Label } from "@/core/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/core/components/ui/select";
import { usePayrollTranslation } from "@/features/payroll/i18n/use-payroll-translation";
import {
  TRANSACTION_STATUSES,
  type TransactionStatus,
} from "@/features/shared/api/enums";

export interface PayrollRunsFiltersValue {
  status?: TransactionStatus;
}

/**
 * Filtres du suivi des lots de paie — statut uniquement : le type est
 * verrouillé à `PAYROLL_CREDIT` par la page (la paie est un type de
 * transaction du wallet-service, §6.3). Sentinelle `SELECT_ALL_VALUE` =
 * « pas de filtre ».
 */
export function PayrollRunsFilters({
  value,
  onChange,
}: {
  value: PayrollRunsFiltersValue;
  onChange: (value: PayrollRunsFiltersValue) => void;
}) {
  const { t } = usePayrollTranslation();

  return (
    <div className="flex flex-wrap items-end gap-4">
      <div className="space-y-1.5">
        <Label>{t("payroll.filters.status")}</Label>
        <Select
          value={value.status ?? SELECT_ALL_VALUE}
          onValueChange={(v) =>
            onChange({
              ...value,
              status: v === SELECT_ALL_VALUE ? undefined : (v as TransactionStatus),
            })
          }
        >
          <SelectTrigger className="w-52">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value={SELECT_ALL_VALUE}>
              {t("payroll.filters.all")}
            </SelectItem>
            {TRANSACTION_STATUSES.map((status) => (
              <SelectItem key={status} value={status} className="notranslate">
                {status}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
